import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { ErrorPage } from '../ErrorPage';
export const SERVER_ERROR_MESSAGE = 'Sorry, the server is unable to handle the request.';
export const ServerErrorPage = memo(function ServerErrorPage({ showContactText }) {
    return (_jsx(ErrorPage, { title: "500", message: SERVER_ERROR_MESSAGE, showContactText: showContactText }, void 0));
});
